<div style="text-align: start">
  <!-- Display thumbnail -->
  <div (click)="tooltipShow = true; clickCount = 0" style="width: auto; display: flex; align-items: center;">
    <!-- Profile Image with Fallback to Default Image and Initials -->
    <div class="profile-image-container {{userImageClass}}" [class.has-image]="user?.meta?.profile_image_url"
      [ngClass]="{'responsive-image': forUserProfile }">
      <img [src]="user?.meta?.profile_image_url" class="profile-image" [ngClass]="{'responsive-image': forUserProfile }"
        *ngIf="user?.meta?.profile_image_url && user?.meta?.profile_image_url !== 'null' && user?.meta?.profile_image_url !== null"
        alt="Contact Person" />
      <ngx-avatars [initialsSize]="2"
        *ngIf="!user?.meta?.profile_image_url || user?.meta?.profile_image_url === 'null' || user?.meta?.profile_image_url === null"
        name="{{ user?.name }}" [size]="sizeAvatar"></ngx-avatars>
    </div>
    <div class="profile-name-section" *ngIf="isName == undefined || isName == true">
      <div class="user-name-row">
        <h3 class="user-name text-wrap-for-user-profile leading-[21px]" [matTooltip]="user?.name"
          matTooltipPosition="below">{{user?.name}}</h3>
        <span *ngIf="showRustAgentBetaBadge" class="agent-beta-badge agent-beta-badge--name"
          [matTooltip]="sysConfig.rustAgentNameBadgeTooltip" matTooltipPosition="below">{{ sysConfig.rustAgentBetaBadge
          }}</span>
      </div>
      <h6 class="user-role flex !items-center gap-2">
        <span>{{ user?.teamRole ? user?.teamRole : user?.role | getUserRole}}</span>
        <span
          *ngIf="showHealth && _sharedService.getUserHealthState(user) == 'UNHEALTHY' || _sharedService.getUserHealthState(user) == 'UNINSTALLED' || _sharedService.getUserHealthState(user) == 'LOGOUT'"
          (mouseenter)="showHealthTooltip($event, user)" (mouseleave)="hideHealthTooltip(user)"
          (click)="$event.stopPropagation(); $event.preventDefault()">
          <span *ngIf="_sharedService.getUserHealthState(user) == 'UNHEALTHY'"
            class="px-1.5 py-1 font-medium rounded-full bg-red-400/10 text-red-600 flex items-center gap-2">
            <span class="block w-2 h-2 bg-red-600 rounded-full"></span>
            Agent Unhealthy
          </span>
          <span *ngIf="_sharedService.getUserHealthState(user) == 'UNINSTALLED'"
            class="px-1.5 py-1 font-medium rounded-full bg-red-400/10 text-red-600 flex items-center gap-2">
            <span class="block w-2 h-2 bg-red-600 rounded-full"></span>
            Agent Uninstalled
          </span>
          <span *ngIf="_sharedService.getUserHealthState(user) == 'LOGOUT'"
            class="px-1.5 py-1 font-medium rounded-full bg-red-400/10 text-red-600 flex items-center gap-2">
            <span class="block w-2 h-2 bg-red-600 rounded-full"></span>
            User Logout
          </span>
        </span>
      </h6>
    </div>
  </div>
</div>
<ng-template #toolTipRef>
  <div style="max-width: 400px" class="userinfo-tooltip">
    <div class="user_avatar_box">
      <!-- Display large image -->
      <div class="tooltip-profile-image-container">
        <img [src]="user?.meta?.profile_image_url" *ngIf="user?.meta?.profile_image_url" />
        <ngx-avatars [initialsSize]="2" *ngIf="!user?.meta?.profile_image_url" name="{{ user?.name }}"
          size="32"></ngx-avatars>
      </div>
      <!-- User Status -->
      <span *ngIf="!user.status || user.status === 'not-using'" class="status" style="background-color: orange"></span>
      <span *ngIf="user.status && user.status === 'online'" class="status_block" class="status"
        style="background-color: green"></span>
      <span *ngIf="user.status && user.status === 'idle'" class="status" style="background-color: #ff9900"></span>
      <span *ngIf="
          user.status && user.status !== 'online' && user.status !== 'not-using' && user.status !== 'idle'
        " class="status" style="background-color: red"></span>
    </div>
    <div class="user_details_box">
      <div class="user-info">
        <span style="float: left; font-size: 20px; font-weight: bold;">
          {{ user?.name }}
        </span>
        <span class="offline-ago" *ngIf="
            user.status && user.status !== 'online' && user.status !== 'not-using' && user.status !== 'idle'
          ">
          {{ getOfflineAgo() }}
        </span>
      </div>
      <div class="row">
        <div class="col 4">
          <button class="btn" style="
              background: rgba(242, 242, 242, 0.5);
              color: black;
              display: flex;
              align-items: center;
              box-shadow: none;
            " (click)="openScreencastActionModel(user)">
            <span class="material-symbols-outlined" id="screencast_request" [ngClass]="
                user.status && user.status == 'online' ? 'online' : 'offline'
              " matTooltip="Screenshot Request">screenshot_monitor</span>
          </button>
        </div>
        <div class="col 4">
          <button class="btn" [disabled]="user.status != 'online'"
            (click)="user.status && user.status == 'online' ? screenshotRequest(user.id, user.status, user?.name): ''">
            <i [ngClass]="
                user.status && user.status == 'online' ? 'online' : 'offline'
              " matTooltip="Screencast Request" class="material-symbols-outlined">live_tv</i>
          </button>
        </div>
        <div class="col 4">
          <button class="btn" style="
              background: rgba(242, 242, 242, 0.5);
              color: black;
              display: flex;
              align-items: center;
              box-shadow: none;
            " (click)="$event.stopPropagation(); userInfo()">
            <span matTooltip="Employee Profile" [routerLink]="['/user-details/', user.id]" [ngClass]="'online'"
              class="material-symbols-outlined">info</span>
          </button>
        </div>
      </div>
      <span>App Used : {{user.meta.last_application_name}}</span>
    </div>
  </div>
</ng-template>


<!-- Floating Health & Integrity Tooltip Container -->
<div
  class="health-tooltip-card fixed z-50 bg-white border border-gray-200 rounded-xl shadow-2xl p-4 w-[360px] pointer-events-auto max-h-[88vh] overflow-y-auto whitespace-normal"
  [style.display]="currentHealthTooltipUser && currentHealthTooltipUser.showHealthTooltip ? 'block' : 'none'"
  [style.top.px]="healthTooltipPosition.top" [style.left.px]="healthTooltipPosition.left"
  (mouseenter)="healthTooltipHovered = true" (mouseleave)="healthTooltipHovered = false; clearHealthTooltip()"
  (click)="$event.stopPropagation(); $event.preventDefault()">

  <!-- Tooltip Header -->
  <div class="flex items-center justify-between !pb-1 !mb-1 border-b border-gray-100">
    <div class="flex items-center gap-2">
      <span class="material-symbols-outlined text-[20px] text-gray-700">shield</span>
      <div>
        <div class="font-semibold text-sm text-gray-900 leading-tight">Client Agent Health</div>
      </div>
    </div>
    <div [ngSwitch]="_sharedService.getUserHealthState(currentHealthTooltipUser)">
      <span *ngSwitchCase="'HEALTHY'"
        class="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-800 flex items-center gap-1">
        <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
        Healthy
      </span>
      <span *ngSwitchCase="'UNHEALTHY'"
        class="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-rose-100 text-rose-800 flex items-center gap-1">
        <span class="w-1.5 h-1.5 rounded-full bg-rose-500 animate-pulse"></span>
        Unhealthy
      </span>
      <span *ngSwitchCase="'STARTING'"
        class="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-800 flex items-center gap-1">
        <span class="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
        Starting
      </span>
      <span *ngSwitchCase="'LOGOUT'"
        class="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-700 flex items-center gap-1">
        <span class="w-1.5 h-1.5 rounded-full bg-gray-500"></span>
        Logout
      </span>
      <span *ngSwitchCase="'UNINSTALLED'"
        class="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-700 flex items-center gap-1">
        <span class="w-1.5 h-1.5 rounded-full bg-gray-500"></span>
        Uninstalled
      </span>
      <span *ngSwitchDefault class="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-600">
        Unknown
      </span>
    </div>
  </div>

  <!-- Last Heartbeat Info -->
  <div class="flex items-center justify-between text-xs text-gray-500 mb-3 py-1.5 px-1">
    <span class="flex items-center gap-1">
      Last Checked:
    </span>
    <span class="font-medium text-gray-700">
      {{ currentHealthTooltipUser?.agentIntegrity?.lastHeartbeatAtUtc ?
      (_sharedService.formatHealthTimestamp(currentHealthTooltipUser.agentIntegrity.lastHeartbeatAtUtc) + ' (' +
      _sharedService.getHealthRelativeTime(currentHealthTooltipUser.agentIntegrity.lastHeartbeatAtUtc) + ')') : 'No
      heartbeat yet' }}
    </span>
  </div>

  <!-- Active Failure Card (Only if latest is Unhealthy) -->
  <div *ngIf="_sharedService.getUserHealthState(currentHealthTooltipUser) === 'UNHEALTHY'" class="mb-3">
    <!-- Unhealthy Status Card -->
    <div class="p-2.5 bg-red-50 border border-red-200 transition-all"
      [ngClass]="isAnyActiveFixExpanded() ? 'rounded-t-lg border-b-0' : 'rounded-lg'">
      
      <!-- Multi Reason List -->
      <div
        *ngIf="_sharedService.getHumanReadableReasonList(_sharedService.getLatestHealthEntry(currentHealthTooltipUser)?.reasonCode).length > 1; else singleReason"
        class="space-y-2">
        <div
          *ngFor="let r of _sharedService.getHumanReadableReasonList(_sharedService.getLatestHealthEntry(currentHealthTooltipUser)?.reasonCode); let rIdx = index"
          class="flex items-start justify-between gap-1.5 text-xs text-red-700 leading-snug">
          <div class="flex items-start gap-1.5 min-w-0 flex-1">
            <span class="text-red-400 mt-0.5 text-[8px] flex-shrink-0">•</span>
            <span class="font-medium whitespace-normal break-words min-w-0 flex-1">{{ r }}</span>
          </div>
          <span
            *ngIf="_sharedService.getReasonFix(_sharedService.getReasonCodeByIndex(_sharedService.getLatestHealthEntry(currentHealthTooltipUser)?.reasonCode, rIdx))"
            (click)="toggleFixAccordion('active_' + rIdx); $event.stopPropagation(); $event.preventDefault()"
            class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-red-100 hover:bg-red-200 text-red-700 border border-red-200 transition-colors cursor-pointer flex-shrink-0 whitespace-nowrap"
            title="Click to view troubleshooting steps">
            <span class="material-symbols-outlined text-[11px] leading-none">build</span>
            <span>Fix It</span>
          </span>
        </div>
      </div>

      <!-- Single Reason -->
      <ng-template #singleReason>
        <div class="flex items-start justify-between gap-2">
          <div class="flex items-start gap-2 min-w-0 flex-1">
            <span class="material-symbols-outlined text-[18px] text-red-600 flex-shrink-0 mt-0.5">error</span>
            <p class="text-xs text-red-700 leading-snug !m-0 font-medium whitespace-normal break-words min-w-0 flex-1">
              {{
              _sharedService.getHumanReadableReason(_sharedService.getLatestHealthEntry(currentHealthTooltipUser)?.reasonCode)
              }}
            </p>
          </div>
          <span
            *ngIf="_sharedService.getReasonFix(_sharedService.getReasonCodeByIndex(_sharedService.getLatestHealthEntry(currentHealthTooltipUser)?.reasonCode, 0))"
            (click)="toggleFixAccordion('active_0'); $event.stopPropagation(); $event.preventDefault()"
            class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-red-100 hover:bg-red-200 text-red-700 border border-red-200 transition-colors cursor-pointer flex-shrink-0 whitespace-nowrap mt-0.5"
            title="Click to view troubleshooting steps">
            <span class="material-symbols-outlined text-[11px] leading-none">build</span>
            <span>Fix It</span>
          </span>
        </div>
      </ng-template>
    </div>

    <!-- Accordion: Steps directly under this unhealthy card -->
    <ng-container
      *ngIf="_sharedService.getHumanReadableReasonList(_sharedService.getLatestHealthEntry(currentHealthTooltipUser)?.reasonCode).length > 1; else singleAccordionSteps">
      <ng-container
        *ngFor="let r of _sharedService.getHumanReadableReasonList(_sharedService.getLatestHealthEntry(currentHealthTooltipUser)?.reasonCode); let rIdx = index">
        <div *ngIf="isFixExpanded('active_' + rIdx)"
          class="bg-slate-50/50 border border-slate-200 rounded-b-lg p-2.5 shadow-sm -mt-[1px]">
          <div class="text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-2 flex items-center justify-between">
            <span class="flex items-center gap-1">
              <span class="material-symbols-outlined text-[13px] text-[#5459d1]" style="color: #5459d1;">checklist</span>
              <span>Troubleshooting Steps</span>
            </span>
            <span class="inline-flex items-center gap-0.5 text-[10px] text-gray-400 font-medium hover:text-gray-700 cursor-pointer transition-colors"
              (click)="toggleFixAccordion('active_' + rIdx); $event.stopPropagation(); $event.preventDefault()">
              <span>Close</span>
              <span class="material-symbols-outlined text-[13px] leading-none">expand_less</span>
            </span>
          </div>
          <div class="space-y-1.5">
            <div *ngFor="let step of getReasonFixSteps(_sharedService.getReasonCodeByIndex(_sharedService.getLatestHealthEntry(currentHealthTooltipUser)?.reasonCode, rIdx)); let sIdx = index"
              class="flex items-start gap-2 text-xs text-gray-700 leading-snug">
              <span class="inline-flex items-center justify-center w-4 h-4 rounded-full text-[10px] font-bold flex-shrink-0 mt-0.5"
                style="background-color: rgba(84, 89, 209, 0.12); color: #5459d1;">
                {{ sIdx + 1 }}
              </span>
              <span class="min-w-0 flex-1 whitespace-normal break-words">{{ step }}</span>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #singleAccordionSteps>
      <div *ngIf="isFixExpanded('active_0')"
        class="bg-slate-50/50 border border-slate-200 rounded-b-lg p-2.5 shadow-sm -mt-[1px]">
        <div class="text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-2 flex items-center justify-between">
          <span class="flex items-center gap-1">
            <span class="material-symbols-outlined text-[13px] text-[#5459d1]" style="color: #5459d1;">checklist</span>
            <span>Troubleshooting Steps</span>
          </span>
          <span class="inline-flex items-center gap-0.5 text-[10px] text-gray-400 font-medium hover:text-gray-700 cursor-pointer transition-colors"
            (click)="toggleFixAccordion('active_0'); $event.stopPropagation(); $event.preventDefault()">
            <span>Close</span>
            <span class="material-symbols-outlined text-[13px] leading-none">expand_less</span>
          </span>
        </div>
        <div class="space-y-1.5">
          <div *ngFor="let step of getReasonFixSteps(_sharedService.getReasonCodeByIndex(_sharedService.getLatestHealthEntry(currentHealthTooltipUser)?.reasonCode, 0)); let sIdx = index"
            class="flex items-start gap-2 text-xs text-gray-700 leading-snug">
            <span class="inline-flex items-center justify-center w-4 h-4 rounded-full text-[10px] font-bold flex-shrink-0 mt-0.5"
              style="background-color: rgba(84, 89, 209, 0.12); color: #5459d1;">
              {{ sIdx + 1 }}
            </span>
            <span class="min-w-0 flex-1 whitespace-normal break-words">{{ step }}</span>
          </div>
        </div>
      </div>
    </ng-template>
  </div>

  <!-- History Logs Section -->
  <div>
    <div class="flex items-center justify-between mb-2">
      <span class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Health History</span>
      <span class="text-[11px] text-gray-400 font-normal">
        {{ _sharedService.getHealthHistory(currentHealthTooltipUser).length }} log(s)
      </span>
    </div>

    <div *ngIf="_sharedService.getHealthHistory(currentHealthTooltipUser).length > 0; else noHistory"
      class="space-y-2 max-h-48 overflow-y-auto pr-1">
      <div *ngFor="let item of _sharedService.getHealthHistory(currentHealthTooltipUser); let idx = index"
        class="p-2 rounded-lg border text-xs" [ngClass]="{
               'border-emerald-200 bg-emerald-50/60': _sharedService.getHealthItemState(item) === 'HEALTHY',
               'border-red-200 bg-red-50/60': _sharedService.getHealthItemState(item) === 'UNHEALTHY',
               'border-blue-200 bg-blue-50/60': _sharedService.getHealthItemState(item) === 'STARTING',
               'border-gray-200 bg-gray-50': _sharedService.getHealthItemState(item) !== 'HEALTHY' && _sharedService.getHealthItemState(item) !== 'UNHEALTHY' && _sharedService.getHealthItemState(item) !== 'STARTING'
             }">
        <div class="flex items-center justify-between mb-1">
          <div class="flex items-center gap-1.5">
            <span class="w-2 h-2 rounded-full" [ngClass]="{
                      'bg-emerald-500': _sharedService.getHealthItemState(item) === 'HEALTHY',
                      'bg-red-500': _sharedService.getHealthItemState(item) === 'UNHEALTHY',
                      'bg-blue-500': _sharedService.getHealthItemState(item) === 'STARTING',
                      'bg-gray-400': _sharedService.getHealthItemState(item) !== 'HEALTHY' && _sharedService.getHealthItemState(item) !== 'UNHEALTHY' && _sharedService.getHealthItemState(item) !== 'STARTING'
                    }"></span>
            <span class="font-semibold text-[11px]" [ngClass]="{
                      'text-emerald-800': _sharedService.getHealthItemState(item) === 'HEALTHY',
                      'text-red-800': _sharedService.getHealthItemState(item) === 'UNHEALTHY',
                      'text-blue-800': _sharedService.getHealthItemState(item) === 'STARTING',
                      'text-gray-700': _sharedService.getHealthItemState(item) !== 'HEALTHY' && _sharedService.getHealthItemState(item) !== 'UNHEALTHY' && _sharedService.getHealthItemState(item) !== 'STARTING'
                    }">
              {{ _sharedService.getHealthItemState(item) }}
            </span>
            <span *ngIf="idx === 0" class="text-[9px] px-1 py-0.2 bg-gray-200 text-gray-600 rounded">Current</span>
          </div>
          <span class="text-[10px] text-gray-500">{{ _sharedService.formatHealthTimestamp(item.timestampUtc) }}</span>
        </div>

        <div *ngIf="_sharedService.getHealthItemState(item) === 'UNHEALTHY'" class="text-[11px] text-red-700 mt-1">
          <!-- Multi-reason in history -->
          <div *ngIf="_sharedService.getHumanReadableReasonList(item.reasonCode).length > 1; else singleItemReason"
            class="space-y-1.5">
            <div *ngFor="let r of _sharedService.getHumanReadableReasonList(item.reasonCode); let rIdx = index"
              class="space-y-1">
              <div class="flex items-start justify-between gap-1.5">
                <div class="flex items-start gap-1 min-w-0 flex-1">
                  <span class="text-red-400 text-[8px] mt-0.5 flex-shrink-0">•</span>
                  <span class="whitespace-normal break-words min-w-0 flex-1">{{ r }}</span>
                </div>
                <span *ngIf="_sharedService.getReasonFix(_sharedService.getReasonCodeByIndex(item.reasonCode, rIdx))"
                  (click)="toggleFixAccordion('hist_' + idx + '_' + rIdx); $event.stopPropagation(); $event.preventDefault()"
                  class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-red-100 hover:bg-red-200 text-red-700 border border-red-200 transition-colors cursor-pointer flex-shrink-0 whitespace-nowrap"
                  title="Click to view troubleshooting steps">
                  <span class="material-symbols-outlined text-[11px] leading-none">build</span>
                  <span>Fix It</span>
                </span>
              </div>
              <!-- Accordion Steps for Multi-Reason in History -->
              <div *ngIf="isFixExpanded('hist_' + idx + '_' + rIdx)"
                class="bg-slate-50/50 border border-slate-200 rounded-md p-2 mt-1.5 shadow-sm">
                <div class="text-[9px] font-semibold text-gray-500 uppercase tracking-wider mb-1.5 flex items-center justify-between">
                  <span class="flex items-center gap-1">
                    <span class="material-symbols-outlined text-[12px] text-[#5459d1]" style="color: #5459d1;">checklist</span>
                    <span>Troubleshooting Steps</span>
                  </span>
                  <span class="inline-flex items-center gap-0.5 text-[9px] text-gray-400 font-medium hover:text-gray-700 cursor-pointer transition-colors"
                    (click)="toggleFixAccordion('hist_' + idx + '_' + rIdx); $event.stopPropagation(); $event.preventDefault()">
                    <span>Close</span>
                    <span class="material-symbols-outlined text-[12px] leading-none">expand_less</span>
                  </span>
                </div>
                <div class="space-y-1.5">
                  <div *ngFor="let step of getReasonFixSteps(_sharedService.getReasonCodeByIndex(item.reasonCode, rIdx)); let sIdx = index"
                    class="flex items-start gap-1.5 text-[11px] text-gray-700 leading-snug">
                    <span class="inline-flex items-center justify-center w-3.5 h-3.5 rounded-full text-[9px] font-bold flex-shrink-0 mt-0.5"
                      style="background-color: rgba(84, 89, 209, 0.12); color: #5459d1;">
                      {{ sIdx + 1 }}
                    </span>
                    <span class="min-w-0 flex-1 whitespace-normal break-words">{{ step }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Single Reason in history -->
          <ng-template #singleItemReason>
            <div>
              <div class="flex items-start justify-between gap-1.5">
                <span class="min-w-0 flex-1 whitespace-normal break-words">{{ _sharedService.getHumanReadableReason(item.reasonCode) }}</span>
                <span *ngIf="_sharedService.getReasonFix(_sharedService.getReasonCodeByIndex(item.reasonCode, 0))"
                  (click)="toggleFixAccordion('hist_' + idx + '_0'); $event.stopPropagation(); $event.preventDefault()"
                  class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-red-100 hover:bg-red-200 text-red-700 border border-red-200 transition-colors cursor-pointer flex-shrink-0 whitespace-nowrap"
                  title="Click to view troubleshooting steps">
                  <span class="material-symbols-outlined text-[11px] leading-none">build</span>
                  <span>Fix It</span>
                </span>
              </div>
              <!-- Accordion Steps for Single Reason in History -->
              <div *ngIf="isFixExpanded('hist_' + idx + '_0')"
                class="bg-slate-50/50 border border-slate-200 rounded-md p-2 mt-1.5 shadow-sm">
                <div class="text-[9px] font-semibold text-gray-500 uppercase tracking-wider mb-1.5 flex items-center justify-between">
                  <span class="flex items-center gap-1">
                    <span class="material-symbols-outlined text-[12px] text-[#5459d1]" style="color: #5459d1;">checklist</span>
                    <span>Troubleshooting Steps</span>
                  </span>
                  <span class="inline-flex items-center gap-0.5 text-[9px] text-gray-400 font-medium hover:text-gray-700 cursor-pointer transition-colors"
                    (click)="toggleFixAccordion('hist_' + idx + '_0'); $event.stopPropagation(); $event.preventDefault()">
                    <span>Close</span>
                    <span class="material-symbols-outlined text-[12px] leading-none">expand_less</span>
                  </span>
                </div>
                <div class="space-y-1.5">
                  <div *ngFor="let step of getReasonFixSteps(_sharedService.getReasonCodeByIndex(item.reasonCode, 0)); let sIdx = index"
                    class="flex items-start gap-1.5 text-[11px] text-gray-700 leading-snug">
                    <span class="inline-flex items-center justify-center w-3.5 h-3.5 rounded-full text-[9px] font-bold flex-shrink-0 mt-0.5"
                      style="background-color: rgba(84, 89, 209, 0.12); color: #5459d1;">
                      {{ sIdx + 1 }}
                    </span>
                    <span class="min-w-0 flex-1 whitespace-normal break-words">{{ step }}</span>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
        <div *ngIf="_sharedService.getHealthItemState(item) === 'LOGOUT'" class="text-[11px] text-gray-600 mt-0.5">
          User logged out
        </div>
        <div *ngIf="_sharedService.getHealthItemState(item) === 'HEALTHY'" class="text-[11px] text-emerald-700">
          All system health checks passing
        </div>
        <div *ngIf="_sharedService.getHealthItemState(item) === 'STARTING'" class="text-[11px] text-blue-700">
          Agent client initializing services
        </div>
        <div *ngIf="_sharedService.getHealthItemState(item) === 'UNINSTALLED'" class="text-[11px] text-gray-600">
          Client agent uninstalled
        </div>
      </div>
    </div>

    <ng-template #noHistory>
      <div class="py-4 text-center text-xs text-gray-400 italic bg-gray-50 rounded-lg">
        No integrity history recorded yet
      </div>
    </ng-template>
  </div>
</div>